import { render, staticRenderFns } from "./WelcomeBanner.vue?vue&type=template&id=76a81947&scoped=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBanner.vue?vue&type=style&index=0&id=76a81947&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a81947",
  null
  
)

export default component.exports